module.exports = __webpack_public_path__ + "img/t.co.png";